<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <h2>Поиск столика</h2>
    <div class="step-info">
      <div class="row">
        <BookingStepInfo
          icon-type="IconBookingPerson"
          :text="filterVisitors"
          class="step-info-step"
          @click="openVisitorsModal"
        />
        <BookingStepInfo
          icon-type="IconBookingCalendar"
          :text="filterDate.toLocaleDateString('ru')"
          class="step-info-step"
          @click="openDateModal"
        />
      </div>

      <div class="row">
        <BookingStepInfo
          icon-type="IconBookingDuration"
          :text="filterDuration / 60 + ' ч'"
          class="step-info-step"
          @click="openDurationModal"
        />
        <BookingStepInfo
          icon-type="IconBookingTime"
          :text="`${filterTime.hours}:${
            filterTime.minutes === 0 ? '00' : filterTime.minutes
          }`"
          class="step-info-step"
          @click="openTimeModal"
        />
      </div>
    </div>
    <div class="buttons">
      <VButton outline gray @click="reset" class="button">Очистить</VButton>
      <VButton @click="accept" class="button">Применить</VButton>
    </div>
  </div>
</template>

<script setup>
import BookingStepInfo from "@/components/pages/w/BookingStepInfo.vue";
import VButton from "@/components/ui/VButton.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";
</script>

<script>
import FilterDurationModal from "@/components/modals/mapCateringFilter/FilterDurationModal.vue";
import FilterDateModal from "@/components/modals/mapCateringFilter/FilterDateModal.vue";
import FilterTimeModal from "@/components/modals/mapCateringFilter/FilterTimeModal.vue";
import FilterVisitorsModal from "@/components/modals/mapCateringFilter/FilterVisitorsModal.vue";

export default {
  name: "CompletedFilterMapModal",

  props: {
    stepInfo: {
      type: Object,
    },
  },

  data() {
    return {
      translateY: 0,
      isSwiping: false,
      threshold: 100,
    };
  },

  computed: {
    city() {
      return this.$store.state.general.city?.city;
    },
    filterDate() {
      return this.$store.state.clientRestaurants.filter.date;
    },
    filterTime() {
      return this.$store.state.clientRestaurants.filter.time;
    },
    filterVisitors() {
      return this.$store.state.clientRestaurants.filter.visitors;
    },
    filterDuration() {
      return this.$store.state.clientRestaurants.filter.duration;
    },
  },

  methods: {
    closeModal() {
      if (this.screenWidth === "mobile") {
        this.$store.dispatch("closeMobileModal");
      } else {
        this.$store.dispatch("closeModal");
      }
    },
    reset() {
      this.$store.commit({
        type: "resetCatFilter",
      });
      this.$store.commit({
        type: "setFilterToggler",
      });
      this.$store.dispatch("openMobileModal", {
        value: {
          component: null,
        },
      });
      this.$store.dispatch("getClientRestaurants", {
        value: { city: this.city, settlement: "" },
      });
    },
    accept() {
      this.$store.dispatch("openMobileModal", {
        value: {
          component: null,
        },
      });
    },
    openDurationModal() {
      this.$store.dispatch("openMobileModal", {
        value: {
          component: FilterDurationModal,
          props: {},
        },
      });
    },
    openDateModal() {
      this.$store.dispatch("openMobileModal", {
        value: {
          component: FilterDateModal,
          props: {},
        },
      });
    },
    openTimeModal() {
      this.$store.dispatch("openMobileModal", {
        value: {
          component: FilterTimeModal,
          props: {},
        },
      });
    },
    openVisitorsModal() {
      this.$store.dispatch("openMobileModal", {
        value: {
          component: FilterVisitorsModal,
          props: {},
        },
      });
    },
    handleSwipeDownStart() {
      this.isSwiping = true;
    },
    handleSwipeDownEnd() {
      if (this.translateY > this.threshold) {
        this.closeModal();
      } else {
        this.translateY = 0;
        this.isSwiping = false;
      }
    },
    handleSwipeMove(event) {
      if (event.deltaY > 0) {
        this.translateY = event.deltaY;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 448px;
  margin: auto;
  padding: 24px 16px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 32px 24px 24px 24px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  margin-bottom: 24px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;

  color: #222222;
}

p {
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #222222;

  .sum {
    font-weight: 600;
    color: #f18e35;
  }

  .entity {
    font-weight: 600;
  }
}

.step-info {
  position: relative;
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  gap: 8px;

  z-index: 199999;

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  @include mobile {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: transparent;
  }

  &-step {
    flex: 1 1 auto;
    height: 56px;
    background-color: #f6f6f6;
    cursor: pointer;

    @include mobile {
      flex: 0 0 auto;
      height: 44px;
      min-width: 152px;
      width: calc(50% - 4px);
      box-shadow: none;
    }
  }
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;

  .button {
    width: 100%;
    height: 40px;
  }
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}
</style>
